import { RouteType } from "../../../types/RouteType";

const moldEngineerAssignmentRoute: RouteType = {
    name: "Mold Engineer Assignment",
    path: "/production/mold-engineer-assignment/:assignmentId?",
    defaultParams: {
        assignmentId: null,
    },
    layout: "/app",
    viewportCard: {
        header: {
            component: () => import("./MoldEngineerAssignment.Header"),
            title: "Mold Engineer Assignment",
            color: "primary",
            enableRefreshButton: true,
            enableBackButton: true,
        },
        body: {
            component: () => import("./MoldEngineerAssignment.Container"),
            grayBackground: false,
        },
    },
    group: 'Production',
  requiresAuth: true,
    requiresPermission: false,
    beforeEnter: async ({ rootStore, params }) => {
        try {
            const moldEngineerAssignmentStore = rootStore.moldEngineerAssignmentStore;
            if (moldEngineerAssignmentStore && typeof moldEngineerAssignmentStore === 'object' && 'loadAssignments' in moldEngineerAssignmentStore) {
                await (moldEngineerAssignmentStore as any).loadAssignments(params.assignmentId);
            }
            return true;
        } catch (error) {
            console.error("Failed to load mold engineer assignments:", error);
            return false;
        }
    },
    onParamsChange: async ({ rootStore, params, previousParams }) => {
        if (params.assignmentId !== previousParams?.assignmentId) {
            const moldEngineerAssignmentStore = rootStore.moldEngineerAssignmentStore;
            if (moldEngineerAssignmentStore && typeof moldEngineerAssignmentStore === 'object' && 'loadAssignments' in moldEngineerAssignmentStore) {
                await (moldEngineerAssignmentStore as any).loadAssignments(params.assignmentId);
            }
        }
    },
    dialogs: [],
};

export default moldEngineerAssignmentRoute;
